// @ts-nocheck
import React from "react";
import { alertErrorMessage } from "../../../customComponents/CustomAlertMessage";
import { loadWithdrawWalletFunds } from "../../../api/services/withdrawService";
import {
  formatFundAvailable,
  formatWithdrawAmountDisplay,
  findFundRowBySymbol,
  truncateMid,
} from "./withdrawPageHelpers";
import {
  AGCE_TRANSFER_DEMO,
  StepBadge,
  WithdrawButtonSpinner,
  WithdrawOtpSendSpinner,
  WITHDRAW_VERIFY_CODE_LEN,
} from "./withdrawPageShared";
import { useWithdrawPage } from "./WithdrawPageContext";

export default function WithdrawPageStep3Overlays() {
  /* eslint-disable no-unused-vars -- context exposes many fields; only subset used in this section */
  const {
    navigate,
    isMobile,
    setIsMobile,
    stepperWrapRef,
    railDims,
    setRailDims,
    withdrawSubmitting,
    setWithdrawSubmitting,
    emailVerifyCode,
    setEmailVerifyCode,
    withdrawOtpSending,
    setWithdrawOtpSending,
    withdrawOtpResendSec,
    setWithdrawOtpResendSec,
    withdrawWithdrawalFlowBusy,
    setWithdrawWithdrawalFlowBusy,
    withdrawConfirmBusy,
    setWithdrawConfirmBusy,
    withdrawSummaryContinueBusy,
    setWithdrawSummaryContinueBusy,
    withdrawalRequestLockRef,
    withdrawHistoryPromiseRef,
    selectedCoin,
    setSelectedCoin,
    withdrawCoins,
    setWithdrawCoins,
    loadingWithdrawCoins,
    setLoadingWithdrawCoins,
    coinSearchQuery,
    setCoinSearchQuery,
    recentWithdrawRows,
    setRecentWithdrawRows,
    loadingWithdrawHistory,
    setLoadingWithdrawHistory,
    fundMain,
    setFundMain,
    selectedWithdrawHistoryRow,
    setSelectedWithdrawHistoryRow,
    selectedNetwork,
    setSelectedNetwork,
    isWithdrawDetailsOpen,
    withdrawToTab,
    setWithdrawToTab,
    agceRecipientTab,
    setAgceRecipientTab,
    agceRecipientEmail,
    setAgceRecipientEmail,
    agceRecipientPhone,
    setAgceRecipientPhone,
    agceRecipientId,
    setAgceRecipientId,
    agceRecipientUsername,
    agceTouched,
    setAgceTouched,
    showAddressBookPanel,
    setShowAddressBookPanel,
    addressBookSubTab,
    setAddressBookSubTab,
    withdrawAddress,
    setWithdrawAddress,
    withdrawAddressTouched,
    setWithdrawAddressTouched,
    withdrawAddressValidError,
    setWithdrawAddressValidError,
    withdrawAddressValidatedKey,
    setWithdrawAddressValidatedKey,
    isWithdrawAddressValidating,
    setIsWithdrawAddressValidating,
    withdrawAddressValidationReqIdRef,
    withdrawAddrValidateDebounceTimerRef,
    withdrawConfirmProceedTimerRef,
    satoshiWhitelistConfirmInFlightRef,
    isAvailSourceOpen,
    setIsAvailSourceOpen,
    isAvailSourcePinned,
    setIsAvailSourcePinned,
    isAvailSourceContextLock,
    setIsAvailSourceContextLock,
    isNetworkFeeInfoOpen,
    setIsNetworkFeeInfoOpen,
    withdrawAmountInput,
    setWithdrawAmountInput,
    withdrawAmountTouched,
    setWithdrawAmountTouched,
    isLimitInfoOpen,
    setIsLimitInfoOpen,
    isWithdrawMetaRefreshing,
    setIsWithdrawMetaRefreshing,
    availSourceRef,
    phoneCountry,
    setPhoneCountry,
    isCountryOpen,
    setIsCountryOpen,
    countryRef,
    isWithdrawConfirmOpen,
    setIsWithdrawConfirmOpen,
    withdrawConfirmRef,
    isAddressVerificationReminderOpen,
    setIsAddressVerificationReminderOpen,
    isWithdrawSummaryOpen,
    setIsWithdrawSummaryOpen,
    withdrawSummaryRef,
    isPasskeyOpen,
    setIsPasskeyOpen,
    passkeyRef,
    isAuthAppOpen,
    setIsAuthAppOpen,
    authAppRef,
    authAppCode,
    setAuthAppCode,
    isChooseAuthOpen,
    setIsChooseAuthOpen,
    chooseAuthRef,
    isEmailVerifyOpen,
    setIsEmailVerifyOpen,
    emailVerifyRef,
    isMobileVerifyOpen,
    setIsMobileVerifyOpen,
    mobileVerifyRef,
    isSecUnavailableOpen,
    setIsSecUnavailableOpen,
    secUnavailable,
    setSecUnavailable,
    isSecResetConfirmOpen,
    setIsSecResetConfirmOpen,
    secResetAck,
    setSecResetAck,
    isSecReqOpen,
    setIsSecReqOpen,
    secReqDone,
    setSecReqDone,
    isRequestSubmittedOpen,
    setIsRequestSubmittedOpen,
    isSecurityResetSuccessOpen,
    setIsSecurityResetSuccessOpen,
    verificationContext,
    setVerificationContext,
    withdrawSecuritySettings,
    setWithdrawSecuritySettings,
    withdrawVerifyMethod,
    setWithdrawVerifyMethod,
    withdrawFundPassword,
    setWithdrawFundPassword,
    withdrawFundPasswordError,
    setWithdrawFundPasswordError,
    withdrawFundPasswordVisible,
    setWithdrawFundPasswordVisible,
    isNoMethodsModalOpen,
    setIsNoMethodsModalOpen,
    isWithdrawVerifyCombinedOpen,
    setIsWithdrawVerifyCombinedOpen,
    withdrawVerifyFieldErrors,
    setWithdrawVerifyFieldErrors,
    mobileVerifyCode,
    setMobileVerifyCode,
    withdrawOtpFallbackAfterPasskey,
    setWithdrawOtpFallbackAfterPasskey,
    closeAllOverlays,
    isAwaitingApprovalOpen,
    setIsAwaitingApprovalOpen,
    awaitingApprovalRef,
    isRecipientAmountOpen,
    setIsRecipientAmountOpen,
    recipientAmountRef,
    isSetPayPinOpen,
    setIsSetPayPinOpen,
    payPinDigits,
    setPayPinDigits,
    payPinShow,
    setPayPinShow,
    payPinRefs,
    isSaveAddressOpen,
    setIsSaveAddressOpen,
    saveAddrLabel,
    setSaveAddrLabel,
    saveAddrCoin,
    setSaveAddrCoin,
    saveAddrUniversal,
    setSaveAddrUniversal,
    saveAddrValue,
    setSaveAddrValue,
    saveAddrNetwork,
    setSaveAddrNetwork,
    saveAddrMemo,
    setSaveAddrMemo,
    saveAddrWhitelistMethod,
    setSaveAddrWhitelistMethod,
    addressWhitelistFlow,
    setAddressWhitelistFlow,
    satoshiDepositAddress,
    setSatoshiDepositAddress,
    satoshiDepositMemo,
    setSatoshiDepositMemo,
    satoshiDepositLoading,
    setSatoshiDepositLoading,
    satoshiDepositError,
    setSatoshiDepositError,
    saveAddrSatoshiPolling,
    setSaveAddrSatoshiPolling,
    satoshiWhitelistAwaitingProof,
    setSatoshiWhitelistAwaitingProof,
    whitelistMetamaskBusy,
    setWhitelistMetamaskBusy,
    metamaskInstallModalOpen,
    setMetamaskInstallModalOpen,
    eip1193BrowserProviderDetected,
    setEip1193BrowserProviderDetected,
    saveAddrSubmitAttempted,
    setSaveAddrSubmitAttempted,
    saveAddrSaving,
    setSaveAddrSaving,
    addressBookEntries,
    setAddressBookEntries,
    addressBookLoading,
    setAddressBookLoading,
    withdrawalAddressHistory,
    setWithdrawalAddressHistory,
    withdrawalAddressHistoryLoading,
    setWithdrawalAddressHistoryLoading,
    addressBookDeleteConfirm,
    setAddressBookDeleteConfirm,
    addressBookDeleteBusy,
    setAddressBookDeleteBusy,
    saveCoinMenuOpen,
    setSaveCoinMenuOpen,
    saveNetworkMenuOpen,
    setSaveNetworkMenuOpen,
    saveCoinSelectRef,
    saveNetworkSelectRef,
    isWithdrawHistoryDetailOpen,
    setIsWithdrawHistoryDetailOpen,
    hideWithdrawErrorNotices,
    setHideWithdrawErrorNotices,
    recentWithdrawTab,
    setRecentWithdrawTab,
    recentWithdrawRowsVisible,
    withdraw24hUsage,
    setWithdraw24hUsage,
    reloadWithdrawCatalog,
    reloadWithdrawal24hUsage,
    refetchWithdrawHistory,
    refetchAddressBook,
    refetchWithdrawalAddressHistory,
    payPinValue,
    isPayPinComplete,
    resetPayPin,
    handlePayPinDigit,
    handlePayPinKeyDown,
    isStep2Done,
    selectedCoinObj,
    isStep1Done,
    activeWithdrawNetworks,
    minWithdrawForSelection,
    effectiveAvailable,
    filteredWithdrawCoins,
    trendingWithdrawCoins,
    coinModalDisplay,
    coinQuickPickDisplay,
    saveAddrCoinOptionsList,
    saveAddrNetworkOptionsEffective,
    saveAddrChainCanonical,
    selectedCoinMeta,
    isWithdrawFormValid,
    withdrawAddressInlineError,
    withdrawAmountInlineError,
    summaryNetworkLabel,
    selectedTokenAssetId,
    validateCurrentWithdrawAddress,
    validateCurrentWithdrawAddressRef,
    applyWithdrawalAddressHistoryEntry,
    withdrawalAddressIsApprovedInBook,
    withdrawStep3Preview,
    getNonPasskeyEnabledMethods,
    hasConfigurableNonPasskeyMethods,
    withdrawCombinedVerificationReady,
    sendSingleWithdrawalOtp,
    withdrawOtpResendActive,
    submitWithdrawalWithEnabledMethods,
    handlePasskeyWithdrawFlow,
    handleWithdrawalSubmitFromCode,
    handleWithdrawalSubmitFundPassword,
    openWithdrawVerificationModal,
    openWithdrawOtpFallbackFromPasskey,
    openWithdrawVerificationCombinedOnly,
    shouldShowPasskeyLink,
    shouldShowSwitchMethodLink,
    openSecurityUnavailableFlow,
    openPasskeysOnlyRequirements,
    closeResetResultOverlays,
    secUnavailableSelectedCount,
    secRequirementsMode,
    secReqTotal,
    secReqCompleted,
    agceErrors,
    handleAgceEmailChange,
    handleAgcePhoneChange,
    handleWithdrawMaxClick,
    handleWithdrawAmountChange,
    copyWithdrawText,
    pasteWithdrawAuthAppCode,
    onWithdrawAgainFromHistory,
    saveAddrErrors,
    isSaveAddrValid,
    saveAddrCoinDisplay,
    saveAddrNetworkDisplay,
    clearSatoshiWhitelistPoll,
    resetSaveAddressFormFields,
    handleWhitelistFlowBack,
    copySatoshiDepositAddress,
    copySatoshiDepositMemo,
    handleSatoshiWhitelistSent,
    handleMetaMaskWhitelistSign,
    resumeMetaMaskWhitelistFromAddressBook,
    resumeSatoshiWhitelistFromAddressBook,
    handleSaveAddressBookSubmit,
    openFreshAddressBookWizard,
    openAddressBookWizardPrefilledFromWithdraw,
    openAddressBookDeleteConfirm,
    confirmAddressBookDelete,
    withdrawProfileReady,
    withdrawKycVerified
  } = useWithdrawPage();
  /* eslint-enable no-unused-vars */

  return (
    <>
      {isStep2Done ? (
        <div className="deposit_step_section select_network_s">
          <div className="deposit_step_header">
            <StepBadge step={3} done={false} />
            <h2>Withdrawal Amount</h2>
          </div>
          <div className="deposit_details_card">


            {isWithdrawDetailsOpen ? (
              <div id="withdraw-details-body" className="withdraw_details_body">


                <div className="withdraw_step3_figma">
                  <div className={`withdraw_amt_field${withdrawAmountInlineError ? " has-error" : ""}`}>
                    <input
                      type="text"
                      inputMode="decimal"
                      autoComplete="off"
                      placeholder={`Minimal ${minWithdrawForSelection}`}
                      value={withdrawAmountInput}
                      onChange={handleWithdrawAmountChange}
                      onBlur={() => setWithdrawAmountTouched(true)}
                      aria-invalid={Boolean(withdrawAmountInlineError)}
                    />
                    <div className="withdraw_amt_suffix" aria-hidden="true">
                      <span className="withdraw_amt_coin">{selectedCoinObj ? selectedCoin : "—"}</span>
                      <span className="withdraw_amt_divider">|</span>
                      <button type="button" className="withdraw_amt_max" onClick={handleWithdrawMaxClick}>
                        MAX
                      </button>
                    </div>
                  </div>
                  {withdrawAmountInlineError ? (
                    <div className="withdraw_inline_error" role="alert">
                      {withdrawAmountInlineError}
                    </div>
                  ) : null}
                  {/*
                          Minimum withdraw hint (disabled for now by requirement)
                          <div className="withdraw_min_hint" role="note">
                            Minimum withdraw:{" "}
                            <strong>
                              {minWithdrawForSelection > 0
                                ? `${formatWithdrawAmountDisplay(minWithdrawForSelection)} ${selectedCoinObj ? selectedCoin : ""}`.trim()
                                : `— ${selectedCoinObj ? selectedCoin : ""}`.trim()}
                            </strong>
                          </div>
                        */}

                  <div className="withdraw_amt_meta_row">
                    <div
                      className="withdraw_amt_meta_left"
                      ref={availSourceRef}
                      onMouseEnter={() => {
                        if (isAvailSourcePinned || isAvailSourceContextLock) return;
                        setIsAvailSourceOpen(true);
                      }}
                      onMouseLeave={() => {
                        if (isAvailSourcePinned || isAvailSourceContextLock) return;
                        setIsAvailSourceOpen(false);
                      }}
                      onContextMenu={() => {
                        // Allow native context menu (Inspect), but keep popup visible.
                        setIsAvailSourceContextLock(true);
                        setIsAvailSourceOpen(true);
                      }}
                    >
                      <button
                        type="button"
                        className="withdraw_amt_meta_title"
                        aria-expanded={isAvailSourceOpen}
                        aria-controls="withdraw-available-source"
                        onClick={() => {
                          setIsAvailSourceContextLock(false);
                          setIsAvailSourcePinned((p) => {
                            const next = !p;
                            setIsAvailSourceOpen(next ? true : false);
                            return next;
                          });
                        }}
                        onContextMenu={() => {
                          setIsAvailSourceContextLock(true);
                          setIsAvailSourceOpen(true);
                        }}
                      >
                        Available Withdraw{" "}
                        <span className="withdraw_amt_meta_value">
                          {formatFundAvailable(findFundRowBySymbol(fundMain, selectedCoin))}{" "}
                          {selectedCoinObj ? selectedCoin : "—"}
                        </span>


                      </button>


                      <div className="withdraw_amt_meta_sub">24h remaining limit</div>


                      {isAvailSourceOpen ? (
                        <div
                          id="withdraw-available-source"
                          className="withdraw_avail_src_pop"
                          role="dialog"
                          onContextMenu={() => {
                            setIsAvailSourceContextLock(true);
                            setIsAvailSourceOpen(true);
                          }}
                        >
                          <div className="withdraw_avail_src_head">Main Wallet</div>

                          <button
                            type="button"
                            className="withdraw_avail_src_item"
                            aria-pressed="true"
                            aria-disabled="true"
                            tabIndex={-1}
                            onClick={(e) => e.preventDefault()}
                          >
                            <span className="withdraw_avail_src_check is-checked" aria-hidden="true">
                              <i className="ri-check-line" />
                            </span>
                            <span className="withdraw_avail_src_txt">
                              <span className="withdraw_avail_src_title">Main Wallet</span>
                              <span className="withdraw_avail_src_amt">
                                {formatFundAvailable(findFundRowBySymbol(fundMain, selectedCoin))}{" "}
                                {selectedCoinObj ? selectedCoin : "—"}
                              </span>
                            </span>
                          </button>

                          <div className="withdraw_avail_src_note">
                            <span className="withdraw_avail_src_bullet" aria-hidden="true">
                              •
                            </span>
                            Withdrawals use your Main Wallet balance only.
                          </div>
                        </div>
                      ) : null}
                    </div>

                    <div className="withdraw_amt_meta_right">

                      <div className="withdraw_amt_net">
                        <span className="withdraw_amt_net_name">{withdrawStep3Preview.networkCode}</span>
                        <button
                          type="button"
                          className="withdraw_amt_refresh"
                          aria-label="Refresh"
                          disabled={isWithdrawMetaRefreshing}
                          onClick={() => {
                            void (async () => {
                              if (isWithdrawMetaRefreshing) return;
                              setIsWithdrawMetaRefreshing(true);
                              try {
                                await reloadWithdrawCatalog();
                                await reloadWithdrawal24hUsage();
                                const { funds } = await loadWithdrawWalletFunds();
                                setFundMain(funds);
                              } finally {
                                setIsWithdrawMetaRefreshing(false);
                              }
                            })();
                          }}
                        >
                          <i className="ri-refresh-line" aria-hidden="true" />
                        </button>
                      </div>
                      <div className="withdraw_amt_nums">
                        <span className="withdraw_limit_left">{withdrawStep3Preview.limitLeft}</span>
                        <span className="withdraw_limit_sep">/</span>
                        <span className="withdraw_limit_right">{withdrawStep3Preview.limitRight}</span>
                        <span
                          className="withdraw_limit_info_wrap"
                          onMouseEnter={() => setIsLimitInfoOpen(true)}
                          onMouseLeave={() => setIsLimitInfoOpen(false)}
                        >
                          <button
                            type="button"
                            className="withdraw_limit_info_btn"
                            aria-label="About 24h withdrawal limit"
                            aria-expanded={isLimitInfoOpen}
                            onClick={() => setIsLimitInfoOpen((v) => !v)}
                          >
                            i
                          </button>
                          {isLimitInfoOpen ? (
                            <div className="withdraw_limit_tooltip" role="tooltip">
                              <div className="withdraw_limit_tip_text">
                                {withdrawStep3Preview.limitLeft} {selectedCoinObj ? selectedCoin : ""} 24 Hour withdrawal limit.
                              </div>
                              {/* <button
                                      type="button"
                                      className="withdraw_limit_tip_link"
                                      onClick={() => {
                                        setIsLimitInfoOpen(false);
                                        // placeholder: wire to KYC/security/upgrade page if available
                                      }}
                                    >
                                      Upgrade
                                    </button> */}
                            </div>
                          ) : null}
                        </span>
                      </div>
                    </div>

                  </div>

                  <div className="withdraw_amt_divline" role="separator" />

                  <div className="withdraw_amt_kv">
                    <div className="withdraw_amt_kv_row">
                      <span className="withdraw_amt_k">Fee</span>
                      <span className="withdraw_amt_v">
                        {withdrawStep3Preview.feeNum != null
                          ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.feeNum)} ${selectedCoinObj ? selectedCoin : "—"
                          }`
                          : `— ${selectedCoinObj ? selectedCoin : "—"}`}
                      </span>
                    </div>
                    <div className="withdraw_amt_kv_row">
                      <span className="withdraw_amt_k">Receive Amount</span>
                      <span className="withdraw_amt_v">
                        {withdrawStep3Preview.receiveNum != null
                          ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.receiveNum)} ${selectedCoinObj ? selectedCoin : "—"
                          }`
                          : `-- ${selectedCoinObj ? selectedCoin : "—"}`}
                      </span>
                    </div>
                    <div className="withdraw_amt_kv_row withdraw_amt_kv_row--netfee">
                      <span />
                      <button
                        type="button"
                        className="withdraw_amt_netfee_btn"
                        aria-expanded={isNetworkFeeInfoOpen}
                        aria-controls="withdraw-network-fee-info"
                        onClick={() => setIsNetworkFeeInfoOpen(true)}
                      >
                        Network Fee{" "}
                        {withdrawStep3Preview.feeNum != null
                          ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.feeNum)} ${selectedCoinObj ? selectedCoin : ""
                          }`
                          : "—"}{" "}
                        <i
                          className={`ri-arrow-right-s-line${isNetworkFeeInfoOpen ? " is-open" : ""}`}
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="withdraw_amt_btn"
                    disabled={!isWithdrawFormValid || withdrawWithdrawalFlowBusy}
                    onClick={async () => {
                      setWithdrawWithdrawalFlowBusy(true);
                      try {
                        setWithdrawAmountTouched(true);
                        if (withdrawToTab === "address" && !withdrawAddress.trim()) {
                          setWithdrawAddressTouched(true);
                          return;
                        }
                        if (withdrawToTab === "address") {
                          const isAddressValid = await validateCurrentWithdrawAddress();
                          if (!isAddressValid) {
                            setWithdrawAddressTouched(true);
                            return;
                          }
                        }
                        if (withdrawAmountInlineError) return;
                        if (
                          withdrawToTab === "address" &&
                          !addressBookLoading &&
                          !withdrawalAddressIsApprovedInBook
                        ) {
                          setIsAddressVerificationReminderOpen(true);
                          return;
                        }
                        closeAllOverlays();
                        setVerificationContext("withdraw");
                        setIsWithdrawConfirmOpen(true);
                      } finally {
                        setWithdrawWithdrawalFlowBusy(false);
                      }
                    }}
                  >
                    {withdrawWithdrawalFlowBusy ? (
                      <>
                        <WithdrawButtonSpinner />
                        Please wait…
                      </>
                    ) : (
                      "Withdrawal"
                    )}
                  </button>

                  <div className="withdraw_amt_warn" role="note">
                    * Beware of scams! AGCX will never ask for personal information or private transfers/withdrawals via SMS,
                    email, or phone. To protect your assets, do not click on unknown links.
                  </div>
                </div>
                {isAddressVerificationReminderOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_confirm_modal withdraw_verify_reminder_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="withdraw_verify_reminder_title"
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsAddressVerificationReminderOpen(false)}
                      >
                        ×
                      </button>
                      <h2 id="withdraw_verify_reminder_title" className="withdraw_verify_reminder_title">
                        Verification Reminder
                      </h2>
                      <p className="withdraw_verify_reminder_text">
                        In line with compliance and travel rule obligations, we need you to register and verify this
                        destination once before we can send funds. Complete the address certification flow a single
                        time; approved addresses are stored in your address book and will not require repeat
                        verification for future withdrawals to the same destination.
                      </p>
                      <div className="withdraw_confirm_actions">

                        <button
                          type="button"
                          className="withdraw_confirm_btn withdraw_confirm_btn--primary"
                          onClick={() => openAddressBookWizardPrefilledFromWithdraw()}
                        >
                          Verify Now
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}
                {isNetworkFeeInfoOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      id="withdraw-network-fee-info"
                      className="withdraw_netfee_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-labelledby="withdraw_netfee_modal_title"
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsNetworkFeeInfoOpen(false)}
                      >
                        ×
                      </button>
                      <h2 id="withdraw_netfee_modal_title" className="withdraw_netfee_panel_title">
                        About Network Fee
                      </h2>
                      <div className="withdraw_netfee_panel_lead">The address you entered is an external wallet address.</div>
                      <p className="withdraw_netfee_panel_text">
                        Withdrawals to external wallet addresses are securely processed via on-chain transactions. Each transaction
                        generates a unique TXID for tracking and transparency, while a network fee is applied based on the selected
                        blockchain to ensure smooth processing.
                      </p>
                      <button type="button" className="withdraw_netfee_panel_link">
                        <a href="/fees"> Learn more about network fees</a>
                      </button>
                      <button
                        type="button"
                        className="withdraw_netfee_panel_ok"
                        onClick={() => setIsNetworkFeeInfoOpen(false)}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ) : null}
                {isWithdrawConfirmOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_confirm_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Withdrawal confirmation"
                      ref={withdrawConfirmRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        disabled={withdrawConfirmBusy}
                        onClick={() => {
                          if (withdrawConfirmProceedTimerRef.current) {
                            window.clearTimeout(withdrawConfirmProceedTimerRef.current);
                            withdrawConfirmProceedTimerRef.current = null;
                          }
                          setWithdrawConfirmBusy(false);
                          setIsWithdrawConfirmOpen(false);
                        }}
                      >
                        ×
                      </button>

                      <div className="withdraw_confirm_icon" aria-hidden="true">
                        <div className="withdraw_confirm_envelope">
                          <img src="/images/email_vector.svg" alt="withdraw confirm icon" />
                        </div>
                      </div>

                      <div className="withdraw_confirm_text">
                        You have chosen the {withdrawStep3Preview.networkCode} network. Kindly verify that your withdrawal address is compatible with this
                        network, as unsupported transfers may result in loss of funds.
                      </div>

                      <div className="withdraw_confirm_actions">
                        <button
                          type="button"
                          className="withdraw_confirm_btn withdraw_confirm_btn--ghost"
                          disabled={withdrawConfirmBusy}
                          onClick={() => {
                            if (withdrawConfirmProceedTimerRef.current) {
                              window.clearTimeout(withdrawConfirmProceedTimerRef.current);
                              withdrawConfirmProceedTimerRef.current = null;
                            }
                            setWithdrawConfirmBusy(false);
                            setIsWithdrawConfirmOpen(false);
                          }}
                        >
                          Return
                        </button>
                        <button
                          type="button"
                          className="withdraw_confirm_btn withdraw_confirm_btn--primary"
                          disabled={withdrawConfirmBusy}
                          onClick={() => {
                            if (withdrawConfirmBusy) return;
                            setWithdrawConfirmBusy(true);
                            withdrawConfirmProceedTimerRef.current = window.setTimeout(() => {
                              withdrawConfirmProceedTimerRef.current = null;
                              setIsWithdrawConfirmOpen(false);
                              closeAllOverlays();
                              setVerificationContext("withdraw");
                              setIsWithdrawSummaryOpen(true);
                              setWithdrawConfirmBusy(false);
                            }, 280);
                          }}
                        >
                          {withdrawConfirmBusy ? (
                            <>
                              <WithdrawButtonSpinner />
                              Confirm…
                            </>
                          ) : (
                            "Confirm"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}
                {isWithdrawSummaryOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_summary_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Withdrawal"
                      ref={withdrawSummaryRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsWithdrawSummaryOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_summary_title">Withdrawal</div>

                      <div className="withdraw_summary_grid" role="table" aria-label="Withdrawal details">
                        <div className="withdraw_summary_row" role="row">
                          <div className="withdraw_summary_k" role="cell">
                            Address
                          </div>
                          <div className="withdraw_summary_v" role="cell">
                            {withdrawAddress.trim() || "—"}
                          </div>
                        </div>
                        <div className="withdraw_summary_row" role="row">
                          <div className="withdraw_summary_k" role="cell">
                            Network
                          </div>
                          <div className="withdraw_summary_v" role="cell">
                            {summaryNetworkLabel}
                          </div>
                        </div>
                        <div className="withdraw_summary_row" role="row">
                          <div className="withdraw_summary_k" role="cell">
                            Amount
                          </div>
                          <div className="withdraw_summary_v" role="cell">
                            {(withdrawAmountInput || "").trim() || "—"}{" "}
                            {selectedCoinObj ? selectedCoin : "—"}
                          </div>
                        </div>
                        <div className="withdraw_summary_row" role="row">
                          <div className="withdraw_summary_k" role="cell">
                            Receive
                          </div>
                          <div className="withdraw_summary_v" role="cell">
                            {withdrawStep3Preview.receiveNum != null
                              ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.receiveNum)} ${selectedCoinObj ? selectedCoin : "—"}`
                              : `— ${selectedCoinObj ? selectedCoin : "—"}`}
                          </div>
                        </div>
                        <div className="withdraw_summary_row" role="row">
                          <div className="withdraw_summary_k" role="cell">
                            Fee
                          </div>
                          <div className="withdraw_summary_v" role="cell">
                            {withdrawStep3Preview.feeNum != null
                              ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.feeNum)} ${selectedCoinObj ? selectedCoin : "—"}`
                              : `— ${selectedCoinObj ? selectedCoin : "—"}`}
                          </div>
                        </div>
                      </div>

                      <div className="withdraw_summary_notes">
                        <div className="withdraw_summary_note">
                          <span className="withdraw_summary_bullet" aria-hidden="true">
                            •
                          </span>
                          Make Sure The Address Is Accurate And Matches The Selected Network.
                        </div>
                        <div className="withdraw_summary_note">
                          <span className="withdraw_summary_bullet" aria-hidden="true">
                            •
                          </span>
                          Once Submitted, Transactions Cannot Be Reversed.
                        </div>
                      </div>

                      <button
                        type="button"
                        className="withdraw_summary_continue"
                        disabled={!isWithdrawFormValid || withdrawSubmitting || withdrawSummaryContinueBusy}
                        onClick={async () => {
                          setWithdrawSummaryContinueBusy(true);
                          try {
                            if (withdrawToTab === "address") {
                              const isAddressValid = await validateCurrentWithdrawAddress();
                              if (!isAddressValid) {
                                setWithdrawAddressTouched(true);
                                alertErrorMessage(withdrawAddressValidError || "Please enter a valid withdrawal address.");
                                return;
                              }
                            }
                            setIsWithdrawSummaryOpen(false);
                            openWithdrawVerificationModal();
                          } finally {
                            setWithdrawSummaryContinueBusy(false);
                          }
                        }}
                      >
                        {withdrawSummaryContinueBusy ? (
                          <>
                            <WithdrawButtonSpinner />
                            Please wait…
                          </>
                        ) : (
                          "Continue"
                        )}
                      </button>
                    </div>
                  </div>
                ) : null}
                {isPasskeyOpen && verificationContext !== "address_book" ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_passkey_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Verify with passkey"
                      ref={passkeyRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsPasskeyOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_passkey_title">Verify with passkey</div>

                      <div className="withdraw_passkey_hero" aria-hidden="true">
                        <img className="light_img" src="/images/passkey_vector_light.svg" alt="" />
                        <img className="dark_img" src="/images/passkey_vector.svg" alt="" />
                      </div>

                      <div className="withdraw_passkey_text">Complete verification using your passkey</div>
                      <div className="withdraw_passkey_subtext">
                        Please follow the instructions on your browser to complete verification.
                      </div>

                      <button
                        type="button"
                        className="withdraw_passkey_verify"
                        disabled={withdrawSubmitting}
                        onClick={() => {
                          setSecReqDone((p) => ({ ...p, passkeys: true }));
                          if (verificationContext === "reset") {
                            setIsPasskeyOpen(false);
                            setIsSecReqOpen(true);
                            return;
                          }
                          void handlePasskeyWithdrawFlow();
                        }}
                      >
                        {withdrawSubmitting ? (
                          <>
                            <WithdrawButtonSpinner />
                            Verifying...
                          </>
                        ) : (
                          "Verify"
                        )}
                      </button>

                      {verificationContext === "reset" ? (
                        <button
                          type="button"
                          className="withdraw_passkey_link"
                          onClick={() => {
                            closeAllOverlays();
                            setVerificationContext("withdraw");
                            setIsAuthAppOpen(true);
                          }}
                        >
                          My Passkeys Are Not Available
                        </button>
                      ) : verificationContext === "withdraw" && hasConfigurableNonPasskeyMethods ? (
                        <button
                          type="button"
                          className="withdraw_passkey_link"
                          onClick={() => void openWithdrawOtpFallbackFromPasskey()}
                        >
                          My Passkeys Are Not Available
                        </button>
                      ) : null}

                      <div className="withdraw_passkey_footer">
                        <img src="/images/protected_icon.svg" alt="shield icon" />
                        <span>Protected by Advanced Encryption</span>
                      </div>
                    </div>
                  </div>
                ) : null}
                {isWithdrawVerifyCombinedOpen && verificationContext === "withdraw" ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_auth_modal withdraw_verify_combined"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Withdrawal security verification"
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsWithdrawVerifyCombinedOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_auth_title">Security verification</div>
                      <div className="withdraw_auth_subtitle">
                        Complete all required steps. For email or SMS, tap Send code to receive your OTP, then enter it
                        below.
                      </div>

                      {getNonPasskeyEnabledMethods().includes("email") ? (
                        <>
                          <div className="withdraw_email_label">Email verification code</div>
                          <div className="withdraw_email_input_row">
                            <input
                              type="text"
                              placeholder="Enter email code"
                              inputMode="numeric"
                              autoComplete="one-time-code"
                              value={emailVerifyCode}
                              onChange={(e) => {
                                setEmailVerifyCode(e.target.value.replace(/\D/g, "").slice(0, WITHDRAW_VERIFY_CODE_LEN));
                                setWithdrawVerifyFieldErrors((p) => ({ ...p, email: "" }));
                              }}
                            />
                            <button
                              type="button"
                              className="withdraw_auth_paste"
                              disabled={withdrawOtpSending.email || withdrawOtpResendSec.email > 0}
                              onClick={() => void sendSingleWithdrawalOtp("email")}
                            >
                              {withdrawOtpSending.email ? (
                                <>
                                  <WithdrawOtpSendSpinner />
                                  Sending…
                                </>
                              ) : withdrawOtpResendSec.email > 0 ? (
                                `Resend in ${withdrawOtpResendSec.email}s`
                              ) : (
                                "Send code"
                              )}
                            </button>
                          </div>
                          {withdrawVerifyFieldErrors.email ? (
                            <p style={{ color: "#e53935", fontSize: 13, marginTop: 4 }}>{withdrawVerifyFieldErrors.email}</p>
                          ) : null}
                        </>
                      ) : null}

                      {getNonPasskeyEnabledMethods().includes("mobile") ? (
                        <>
                          <div className="withdraw_email_label withdraw_verify_combined_spaced">Mobile verification code</div>
                          <div className="withdraw_email_input_row">
                            <input
                              type="text"
                              inputMode="numeric"
                              placeholder="Enter mobile code"
                              autoComplete="one-time-code"
                              value={mobileVerifyCode}
                              onChange={(e) => {
                                setMobileVerifyCode(e.target.value.replace(/\D/g, "").slice(0, WITHDRAW_VERIFY_CODE_LEN));
                                setWithdrawVerifyFieldErrors((p) => ({ ...p, mobile: "" }));
                              }}
                            />
                            <button
                              type="button"
                              className="withdraw_auth_paste"
                              disabled={withdrawOtpSending.mobile || withdrawOtpResendSec.mobile > 0}
                              onClick={() => void sendSingleWithdrawalOtp("mobile")}
                            >
                              {withdrawOtpSending.mobile ? (
                                <>
                                  <WithdrawOtpSendSpinner />
                                  Sending…
                                </>
                              ) : withdrawOtpResendSec.mobile > 0 ? (
                                `Resend in ${withdrawOtpResendSec.mobile}s`
                              ) : (
                                "Send code"
                              )}
                            </button>
                          </div>
                          {withdrawVerifyFieldErrors.mobile ? (
                            <p style={{ color: "#e53935", fontSize: 13, marginTop: 4 }}>{withdrawVerifyFieldErrors.mobile}</p>
                          ) : null}
                        </>
                      ) : null}

                      {getNonPasskeyEnabledMethods().includes("google_authenticator") ? (
                        <>
                          <div className="withdraw_auth_label withdraw_verify_combined_spaced">Authenticator app</div>
                          <div className="withdraw_auth_input_row">
                            <input
                              type="text"
                              placeholder="Enter authenticator app code"
                              inputMode="numeric"
                              autoComplete="one-time-code"
                              value={authAppCode}
                              onChange={(e) => {
                                setAuthAppCode(e.target.value.replace(/\D/g, "").slice(0, WITHDRAW_VERIFY_CODE_LEN));
                                setWithdrawVerifyFieldErrors((p) => ({ ...p, google_authenticator: "" }));
                              }}
                            />
                            <button type="button" className="withdraw_auth_paste" onClick={() => void pasteWithdrawAuthAppCode()}>
                              Paste
                            </button>
                          </div>
                          {withdrawVerifyFieldErrors.google_authenticator ? (
                            <p style={{ color: "#e53935", fontSize: 13, marginTop: 4 }}>
                              {withdrawVerifyFieldErrors.google_authenticator}
                            </p>
                          ) : null}
                        </>
                      ) : null}

                      {getNonPasskeyEnabledMethods().includes("fund_password") ? (
                        <>
                          <div className="withdraw_auth_label withdraw_verify_combined_spaced">Fund password</div>
                          <div className="withdraw_auth_input_row">
                            <input
                              type={withdrawFundPasswordVisible ? "text" : "password"}
                              autoComplete="current-password"
                              placeholder="Enter fund password"
                              value={withdrawFundPassword}
                              onChange={(e) => {
                                setWithdrawFundPassword(e.target.value);
                                setWithdrawFundPasswordError("");
                                setWithdrawVerifyFieldErrors((p) => ({ ...p, fund_password: "" }));
                              }}
                            />
                            <button
                              type="button"
                              className="withdraw_fund_password_toggle"
                              aria-label={withdrawFundPasswordVisible ? "Hide fund password" : "Show fund password"}
                              onClick={() => setWithdrawFundPasswordVisible((v) => !v)}
                            >
                              <i className={withdrawFundPasswordVisible ? "ri-eye-line" : "ri-eye-off-line"} aria-hidden="true" />
                            </button>
                          </div>
                          {(withdrawFundPasswordError || withdrawVerifyFieldErrors.fund_password) ? (
                            <p style={{ color: "#e53935", fontSize: 13, marginTop: 4 }}>
                              {withdrawVerifyFieldErrors.fund_password || withdrawFundPasswordError}
                            </p>
                          ) : null}
                        </>
                      ) : null}

                      <button
                        type="button"
                        className="withdraw_auth_submit withdraw_verify_combined_spaced"
                        disabled={withdrawSubmitting || !withdrawCombinedVerificationReady}
                        onClick={() => void submitWithdrawalWithEnabledMethods({})}
                      >
                        {withdrawSubmitting ? (
                          <>
                            <WithdrawButtonSpinner />
                            Submitting…
                          </>
                        ) : (
                          "Confirm withdrawal"
                        )}
                      </button>

                      <div className="withdraw_passkey_footer withdraw_auth_footer">
                        <img src="/images/protected_icon.svg" alt="shield icon" />
                        <span>Protected by Advanced Encryption</span>
                      </div>
                    </div>
                  </div>
                ) : null}
                {isAuthAppOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_auth_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Authenticator App Verification"
                      ref={authAppRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsAuthAppOpen(false)}
                      >
                        ×
                      </button>

                      {withdrawVerifyMethod === "fund_password" && verificationContext === "withdraw" ? (
                        <>
                          <div className="withdraw_auth_title">Fund Password Verification</div>
                          <div className="withdraw_auth_subtitle">Enter your fund password to confirm this withdrawal.</div>
                          <div className="withdraw_auth_label">Fund Password</div>
                          <div className="withdraw_auth_input_row">
                            <input
                              type={withdrawFundPasswordVisible ? "text" : "password"}
                              autoComplete="current-password"
                              placeholder="Enter fund password"
                              value={withdrawFundPassword}
                              onChange={(e) => { setWithdrawFundPassword(e.target.value); setWithdrawFundPasswordError(""); }}
                            />
                            <button
                              type="button"
                              className="withdraw_fund_password_toggle"
                              aria-label={withdrawFundPasswordVisible ? "Hide fund password" : "Show fund password"}
                              onClick={() => setWithdrawFundPasswordVisible((v) => !v)}
                            >
                              <i className={withdrawFundPasswordVisible ? "ri-eye-line" : "ri-eye-off-line"} aria-hidden="true" />
                            </button>
                          </div>
                          {withdrawFundPasswordError && (
                            <p style={{ color: "#e53935", fontSize: 13, marginTop: 4 }}>{withdrawFundPasswordError}</p>
                          )}
                          <button
                            type="button"
                            className="withdraw_auth_submit"
                            disabled={withdrawSubmitting || !withdrawFundPassword.trim()}
                            onClick={() => void handleWithdrawalSubmitFundPassword()}
                          >
                            {withdrawSubmitting ? (
                              <>
                                <WithdrawButtonSpinner />
                                Submitting...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </>
                      ) : (
                        <>
                          <div className="withdraw_auth_title">Authenticator App Verification</div>
                          <div className="withdraw_auth_subtitle">
                            Enter the 6-digit code generated by the<br />
                            Authenticator App.
                          </div>
                          <div className="withdraw_auth_label">Authenticator App</div>
                          <div className="withdraw_auth_input_row">
                            <input
                              type="text"
                              inputMode="numeric"
                              autoComplete="one-time-code"
                              placeholder=""
                              value={authAppCode}
                              onChange={(e) =>
                                setAuthAppCode(
                                  e.target.value.replace(/\D/g, "").slice(0, WITHDRAW_VERIFY_CODE_LEN)
                                )
                              }
                            />
                            <button type="button" className="withdraw_auth_paste" onClick={() => void pasteWithdrawAuthAppCode()}>
                              Paste
                            </button>
                          </div>
                          <button
                            type="button"
                            className="withdraw_auth_submit"
                            disabled={withdrawSubmitting}
                            onClick={() => {
                              if (!authAppCode?.trim()) return;
                              setSecReqDone((p) => ({ ...p, authApp: true }));
                              if (verificationContext === "reset") {
                                setIsAuthAppOpen(false);
                                setIsSecReqOpen(true);
                                return;
                              }
                              if (withdrawToTab === "address" && verificationContext === "withdraw") {
                                setWithdrawVerifyMethod("google_authenticator");
                                void handleWithdrawalSubmitFromCode(authAppCode.trim());
                                return;
                              }
                              setIsAuthAppOpen(false);
                              if (withdrawToTab === "agce_user") setIsRecipientAmountOpen(true);
                              else setIsAwaitingApprovalOpen(true);
                            }}
                          >
                            {withdrawSubmitting ? (
                              <>
                                <WithdrawButtonSpinner />
                                Submitting...
                              </>
                            ) : (
                              "Submit"
                            )}
                          </button>
                        </>
                      )}


                      <div className="gapbtn_space">

                        {shouldShowPasskeyLink(withdrawVerifyMethod) ? (
                          <button
                            type="button"
                            className="withdraw_auth_link"
                            onClick={() => {
                              setIsAuthAppOpen(false);
                              setIsPasskeyOpen(true);
                            }}
                          >
                            Use Passkeys to Complete Verification
                          </button>
                        ) : null}
                        {shouldShowSwitchMethodLink(withdrawVerifyMethod) ? (
                          <button
                            type="button"
                            className="withdraw_auth_link"
                            onClick={() => {
                              setIsAuthAppOpen(false);
                              openWithdrawVerificationCombinedOnly();
                            }}
                          >
                            Switch to Another Verification Method
                          </button>
                        ) : null}
                        {/* <button type="button" className="withdraw_auth_link" onClick={openSecurityUnavailableFlow}>
                                  Security verification unavailable?
                                </button> */}
                      </div>

                      <div className="withdraw_passkey_footer withdraw_auth_footer">
                        <img src="/images/protected_icon.svg" alt="shield icon" />
                        <span>Protected by Advanced Encryption</span>
                      </div>
                    </div>
                  </div>
                ) : null}
                {/* ── No verification methods configured — Security Risk Warning ── */}
                {isNoMethodsModalOpen ? (
                  <div className="withdraw_confirm_overlay withdraw_sec_overlay" role="presentation" onClick={(e) => e.stopPropagation()}>
                    <div className="withdraw_sec_modal" role="dialog" aria-modal="true" aria-label="Security Risk Warning">
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsNoMethodsModalOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_confirm_icon" aria-hidden="true">
                        <div className="withdraw_confirm_envelope">
                          <img src="/images/security/Container3.svg" alt="" />
                        </div>
                      </div>

                      <div className="withdraw_sec_title">Security Risk Warning</div>
                      <div className="withdraw_sec_subtitle">
                        To enhance your account security, please activate at least one additional verification method.
                      </div>

                      <div className="withdraw_sec_list">
                        <button
                          type="button"
                          className="withdraw_sec_item"
                          onClick={() => { setIsNoMethodsModalOpen(false); navigate("/user_profile/security?tab=email"); }}
                        >
                          <span className="withdraw_sec_item_left">
                            <span className="withdraw_sec_icon" aria-hidden="true">
                              <img src="/images/email_vector2.svg" alt="" />
                            </span>
                            <span className="withdraw_sec_item_txt">
                              <span className="withdraw_sec_item_title">Email Verification</span>
                              <span className="withdraw_sec_item_sub">Receive OTP codes to your email</span>
                            </span>
                          </span>
                          <i className="ri-arrow-right-long-line" aria-hidden="true" />
                        </button>

                        <button
                          type="button"
                          className="withdraw_sec_item"
                          onClick={() => { setIsNoMethodsModalOpen(false); navigate("/user_profile/security?tab=2fa"); }}
                        >
                          <span className="withdraw_sec_item_left">
                            <span className="withdraw_sec_icon" aria-hidden="true">
                              <img src="/images/security/authenticator.svg" alt="" />
                            </span>
                            <span className="withdraw_sec_item_txt">
                              <span className="withdraw_sec_item_title">Google Authenticator</span>
                              <span className="withdraw_sec_item_sub">Use an authenticator app for TOTP codes</span>
                            </span>
                          </span>
                          <i className="ri-arrow-right-long-line" aria-hidden="true" />
                        </button>

                        <button
                          type="button"
                          className="withdraw_sec_item"
                          onClick={() => { setIsNoMethodsModalOpen(false); navigate("/user_profile/security?tab=fund_password"); }}
                        >
                          <span className="withdraw_sec_item_left">
                            <span className="withdraw_sec_icon" aria-hidden="true">
                              <img src="/images/security/passkey.svg" alt="" />
                            </span>
                            <span className="withdraw_sec_item_txt">
                              <span className="withdraw_sec_item_title">Fund Password</span>
                              <span className="withdraw_sec_item_sub">Set a separate password for withdrawals</span>
                            </span>
                          </span>
                          <i className="ri-arrow-right-long-line" aria-hidden="true" />
                        </button>
                      </div>

                      <button
                        type="button"
                        className="withdraw_sec_help"
                        onClick={() => setIsNoMethodsModalOpen(false)}
                      >
                        Maybe Later
                      </button>
                    </div>
                  </div>
                ) : null}

                {isAwaitingApprovalOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_await_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Awaiting Approval"
                      ref={awaitingApprovalRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => {
                          setIsAwaitingApprovalOpen(false);
                          if (new URLSearchParams(window.location.search).get("awaiting") === "1") {
                            navigate(window.location.pathname, { replace: true });
                          }
                        }}
                      >
                        ×
                      </button>

                      <div className="withdraw_await_icon" aria-hidden="true">
                        <span className="withdraw_await_circle">
                          <img src="/images/awaiting_vector.svg" alt="hourglass icon" />
                        </span>
                      </div>

                      <div className="withdraw_await_title">Awaiting Approval</div>
                      <div className="withdraw_await_text">
                        Your withdrawal request is waiting for admin approval. Funds are locked until it is approved or
                        you cancel it. You can check the status anytime in your withdrawal history.
                      </div>

                      <button
                        type="button"
                        className="withdraw_await_ok"
                        onClick={() => {
                          setIsAwaitingApprovalOpen(false);
                          if (new URLSearchParams(window.location.search).get("awaiting") === "1") {
                            navigate(window.location.pathname, { replace: true });
                          }
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ) : null}
                {isRecipientAmountOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_recipient_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Recipient Amount"
                      ref={recipientAmountRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsRecipientAmountOpen(false)}
                      >
                        ×
                      </button>

                      {withdrawToTab === "agce_user" ? (
                        <>
                          <div className="withdraw_recipient_icon" aria-hidden="true">
                            <span className="withdraw_sucessfull_icon">
                              <img src="/images/sucessfull_payment_icon.svg" alt="hourglass icon" />
                            </span>
                          </div>

                          <div className="withdraw_recipient_title">Recipient Amount</div>
                          <div className="withdraw_coin_hd">USDT</div>
                          <div className="withdraw_recipient_note">
                            The transfer has been successfully completed.
                          </div>

                          <div className="withdraw_recipient_grid" role="table" aria-label="Transfer details">
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Transfer Method
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {AGCE_TRANSFER_DEMO.methodLabel}
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Recipient
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {(agceRecipientId || "").trim() || AGCE_TRANSFER_DEMO.recipient}
                                <div className="withdraw_recipient_sub">
                                  Username: {agceRecipientUsername}
                                </div>
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Total Paid
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                0.01 USDT
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Source Wallet
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {AGCE_TRANSFER_DEMO.sourceWallet}
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Note
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {AGCE_TRANSFER_DEMO.note}
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Order ID
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                123457654323456
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Time
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                2026-04-13 16:14:23
                              </div>
                            </div>
                          </div>

                          <button
                            type="button"
                            className="withdraw_paypin_link"
                            onClick={() => {
                              setIsRecipientAmountOpen(false);
                              resetPayPin();
                              setIsSetPayPinOpen(true);
                            }}
                          >
                            Set a Pay PIN for faster and secure payments
                          </button>

                          <button type="button" className="withdraw_await_ok" onClick={() => setIsRecipientAmountOpen(false)}>
                            OK
                          </button>
                        </>
                      ) : (
                        <>
                          <div className="withdraw_recipient_icon" aria-hidden="true">
                            <span className="withdraw_recipient_check">
                              <img src="/images/rightarrow2.svg" alt="check icon" />
                            </span>
                          </div>

                          <div className="withdraw_recipient_title">Recipient Amount</div>
                          <div className="withdraw_recipient_amt">
                            {withdrawStep3Preview.receiveNum != null
                              ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.receiveNum)} ${selectedCoinObj ? selectedCoin : "—"}`
                              : `— ${selectedCoinObj ? selectedCoin : "—"}`}
                          </div>
                          <div className="withdraw_recipient_note">
                            Please note that you will receive an email once it is completed.
                          </div>

                          <div className="withdraw_recipient_grid" role="table" aria-label="Withdrawal details">
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Address
                              </div>
                              <div className="withdraw_recipient_v withdraw_recipient_v--addr" role="cell">
                                <span>{truncateMid(withdrawAddress.trim() || "—", 10, 8)}</span>
                                <button
                                  type="button"
                                  className="withdraw_recipient_addr_icon"
                                  aria-label="Save address"
                                  onClick={() => openFreshAddressBookWizard()}
                                >
                                  <img src="/images/user3.svg" alt="" aria-hidden="true" />
                                </button>
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Network
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {summaryNetworkLabel}
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Amount
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {(withdrawAmountInput || "").trim() || "—"} {selectedCoinObj ? selectedCoin : "—"}
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Receive
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {withdrawStep3Preview.receiveNum != null
                                  ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.receiveNum)} ${selectedCoinObj ? selectedCoin : "—"}`
                                  : `— ${selectedCoinObj ? selectedCoin : "—"}`}
                              </div>
                            </div>
                            <div className="withdraw_recipient_row" role="row">
                              <div className="withdraw_recipient_k" role="cell">
                                Fee
                              </div>
                              <div className="withdraw_recipient_v" role="cell">
                                {withdrawStep3Preview.feeNum != null
                                  ? `${formatWithdrawAmountDisplay(withdrawStep3Preview.feeNum)} ${selectedCoinObj ? selectedCoin : "—"}`
                                  : `— ${selectedCoinObj ? selectedCoin : "—"}`}
                              </div>
                            </div>
                          </div>

                          <div className="withdraw_recipient_actions">
                            {/* <button
                                      type="button"
                                      className="withdraw_recipient_btn withdraw_recipient_btn--ghost"
                                      onClick={() => setIsRecipientAmountOpen(false)}
                                    >
                                      Ok
                                    </button> */}
                            <button
                              type="button"
                              className="withdraw_recipient_btn withdraw_recipient_btn--primary"
                              onClick={() => setIsRecipientAmountOpen(false)}
                            >
                              Done
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ) : null}
                {isChooseAuthOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_choose_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Choose an Authenticator"
                      ref={chooseAuthRef}
                    >
                      <div className="withdraw_choose_topbar">
                        <button
                          type="button"
                          className="withdraw_choose_back"
                          aria-label="Back"
                          onClick={() => {
                            setIsChooseAuthOpen(false);
                            setIsAuthAppOpen(true);
                          }}
                        >
                          <i className="ri-arrow-left-long-line" aria-hidden="true" />
                        </button>
                        <button
                          type="button"
                          className="withdraw_confirm_close"
                          aria-label="Close"
                          onClick={() => setIsChooseAuthOpen(false)}
                        >
                          ×
                        </button>
                      </div>

                      <div className="withdraw_choose_title">Choose an Authenticator</div>
                      <div className="withdraw_choose_subtitle">
                        Enter the 6-digit code generated by the<br />
                        Authenticator App.
                      </div>

                      <div className="emailphone_outerbl">

                        <button
                          type="button"
                          className="withdraw_choose_item"
                          onClick={() => {
                            setIsChooseAuthOpen(false);
                            setIsEmailVerifyOpen(true);
                          }}
                        >
                          <img src="/images/email_vector2.svg" alt="" aria-hidden="true" />
                          <span>Email</span>
                        </button>

                        <button
                          type="button"
                          className="withdraw_choose_item authenticator"
                          onClick={() => {
                            setIsChooseAuthOpen(false);
                            setIsAuthAppOpen(true);
                          }}
                        >
                          <img src="/images/authenticator_icon.svg" alt="" aria-hidden="true" />
                          <span>Authenticator App</span>
                        </button>

                        <button
                          type="button"
                          className="withdraw_choose_item mobilebtnpop"
                          onClick={() => {
                            setIsChooseAuthOpen(false);
                            setIsMobileVerifyOpen(true);
                          }}
                        >
                          <img src="/images/mobileicon.svg" alt="" aria-hidden="true" />
                          <span>Mobile</span>
                        </button>

                      </div>

                      <div className="mid_use_text">
                        {shouldShowPasskeyLink("choose_auth") ? (
                          <button
                            type="button"
                            className="withdraw_auth_link"
                            onClick={() => {
                              setIsChooseAuthOpen(false);
                              setIsPasskeyOpen(true);
                            }}
                          >
                            Use Passkeys to Complete Verification
                          </button>
                        ) : null}

                        {/* <button type="button" className="withdraw_auth_link" onClick={openSecurityUnavailableFlow}>
                                  Security verification unavailable?
                                </button> */}

                      </div>

                      <div className="withdraw_passkey_footer withdraw_auth_footer passkey_footer_text">
                        <div className="withdraw_passkey_footer__inner">
                          <img src="/images/protected_icon.svg" alt="shield icon" />
                          <span>Protected by Advanced Encryption</span>
                        </div>
                      </div>


                    </div>
                  </div>
                ) : null}
                {isEmailVerifyOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_email_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Email Verification"
                      ref={emailVerifyRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsEmailVerifyOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_email_title">Email Verification</div>
                      <div className="withdraw_email_subtitle">
                        Enter the 6-digit code Verification code sent to<br />
                        hal***@gmail.com
                      </div>

                      <div className="withdraw_email_label">Email Verification Code</div>
                      <div className="withdraw_email_input_row">
                        <input
                          type="text"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          placeholder=""
                          value={emailVerifyCode}
                          onChange={(e) =>
                            setEmailVerifyCode(
                              e.target.value.replace(/\D/g, "").slice(0, WITHDRAW_VERIFY_CODE_LEN)
                            )
                          }
                        />
                        <span className="withdraw_email_status">
                          {withdrawOtpSending.email ? "Sending..." : "Code Sent"}
                        </span>
                      </div>

                      <button
                        type="button"
                        className="withdraw_email_submit"
                        disabled={withdrawSubmitting}
                        onClick={() => {
                          if (verificationContext === "withdraw" && withdrawToTab === "address") {
                            void handleWithdrawalSubmitFromCode(emailVerifyCode);
                            return;
                          }
                          setIsEmailVerifyOpen(false);
                          setSecReqDone((p) => ({ ...p, email: true }));
                          if (verificationContext === "reset") setIsSecReqOpen(true);
                        }}
                      >
                        {withdrawSubmitting ? (
                          <>
                            <WithdrawButtonSpinner />
                            Submitting...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>

                      <div className="gapbtn_space">

                        {shouldShowPasskeyLink("email") ? (
                          <button
                            type="button"
                            className="withdraw_auth_link"
                            onClick={() => {
                              setIsEmailVerifyOpen(false);
                              setIsPasskeyOpen(true);
                            }}
                          >
                            Use Passkeys to Complete Verification
                          </button>
                        ) : null}
                        {shouldShowSwitchMethodLink("email") ? (
                          <button
                            type="button"
                            className="withdraw_auth_link"
                            onClick={() => {
                              setIsEmailVerifyOpen(false);
                              openWithdrawVerificationCombinedOnly();
                            }}
                          >
                            Switch to Another Verification Method
                          </button>
                        ) : null}
                        {/* <button type="button" className="withdraw_auth_link" onClick={openSecurityUnavailableFlow}>
                                  Security verification unavailable?
                                </button> */}

                      </div>

                      <div className="withdraw_passkey_footer withdraw_auth_footer">
                        <img src="/images/protected_icon.svg" alt="shield icon" />
                        <span>Protected by Advanced Encryption</span>
                      </div>
                    </div>
                  </div>
                ) : null}
                {isMobileVerifyOpen ? (
                  <div className="withdraw_confirm_overlay" role="presentation">
                    <div
                      className="withdraw_email_modal"
                      role="dialog"
                      aria-modal="true"
                      aria-label="Mobile Verification"
                      ref={mobileVerifyRef}
                    >
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsMobileVerifyOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_email_title">Mobile Verification</div>
                      <div className="withdraw_email_subtitle">
                        <>
                          Enter the 6-digit verification code sent to<br />
                          +91 *****1234
                        </>
                      </div>

                      <div className="withdraw_email_label">Mobile Verification Code</div>
                      <div className="withdraw_email_input_row">
                        <input
                          type="text"
                          inputMode="numeric"
                          autoComplete="one-time-code"
                          placeholder=""
                          value={mobileVerifyCode}
                          onChange={(e) =>
                            setMobileVerifyCode(
                              e.target.value.replace(/\D/g, "").slice(0, WITHDRAW_VERIFY_CODE_LEN)
                            )
                          }
                        />
                        <span className="withdraw_email_status">
                          {withdrawOtpSending.mobile ? "Sending..." : "Code Sent"}
                        </span>
                      </div>

                      <button
                        type="button"
                        className="withdraw_email_submit"
                        disabled={withdrawSubmitting}
                        onClick={() => {
                          if (verificationContext === "withdraw") {
                            setWithdrawVerifyMethod("mobile");
                            void handleWithdrawalSubmitFromCode(mobileVerifyCode);
                          } else {
                            setIsMobileVerifyOpen(false);
                            setSecReqDone((p) => ({ ...p, phone: true }));
                            if (verificationContext === "reset") setIsSecReqOpen(true);
                          }
                        }}
                      >
                        {withdrawSubmitting ? (
                          <>
                            <WithdrawButtonSpinner />
                            Submitting...
                          </>
                        ) : (
                          "Submit"
                        )}
                      </button>

                      <div className="gapbtn_space">

                        {shouldShowPasskeyLink("mobile") ? (
                          <button
                            type="button"
                            className="withdraw_auth_link"
                            onClick={() => {
                              setIsMobileVerifyOpen(false);
                              setIsPasskeyOpen(true);
                            }}
                          >
                            Use Passkeys to Complete Verification
                          </button>
                        ) : null}
                        {shouldShowSwitchMethodLink("mobile") ? (
                          <button
                            type="button"
                            className="withdraw_auth_link"
                            onClick={() => {
                              setIsMobileVerifyOpen(false);
                              openWithdrawVerificationCombinedOnly();
                            }}
                          >
                            Switch to Another Verification Method
                          </button>
                        ) : null}
                        {/* <button type="button" className="withdraw_auth_link" onClick={openSecurityUnavailableFlow}>
                                  Security verification unavailable?
                                </button> */}

                      </div>

                      <div className="withdraw_passkey_footer withdraw_auth_footer">
                        <img src="/images/protected_icon.svg" alt="shield icon" />
                        <span>Protected by Advanced Encryption</span>
                      </div>
                    </div>
                  </div>
                ) : null}
                {false ? (
                  <div className="withdraw_confirm_overlay withdraw_sec_overlay" role="presentation">
                    <div className="withdraw_sec_modal" role="dialog" aria-modal="true" aria-label="Select Unavailable Methods">
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsSecUnavailableOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_sec_title">Select Unavailable Methods</div>
                      <div className="withdraw_sec_subtitle">
                        Please select all security methods you can no longer access and want to reset.
                      </div>

                      <div className="withdraw_sec_list">
                        <button
                          type="button"
                          className="withdraw_sec_item"
                          onClick={() => setSecUnavailable((p) => ({ ...p, email: !p.email }))}
                        >
                          <span className="withdraw_sec_item_left">
                            <span className="withdraw_sec_icon" aria-hidden="true">
                              <i className="ri-mail-line" />
                            </span>
                            <span className="withdraw_sec_item_txt">
                              <span className="withdraw_sec_item_title">Email</span>
                              <span className="withdraw_sec_item_sub">pa****@gmail.com</span>
                            </span>
                          </span>
                          <span className={`withdraw_sec_check${secUnavailable.email ? " is-checked" : ""}`} aria-hidden="true" />
                        </button>

                        <button
                          type="button"
                          className="withdraw_sec_item"
                          onClick={() => setSecUnavailable((p) => ({ ...p, phone: !p.phone }))}
                        >
                          <span className="withdraw_sec_item_left">
                            <span className="withdraw_sec_icon" aria-hidden="true">
                              <i className="ri-smartphone-line" />
                            </span>
                            <span className="withdraw_sec_item_txt">
                              <span className="withdraw_sec_item_title">Phone Number</span>
                              <span className="withdraw_sec_item_sub">998****1988</span>
                            </span>
                          </span>
                          <span className={`withdraw_sec_check${secUnavailable.phone ? " is-checked" : ""}`} aria-hidden="true" />
                        </button>

                        <button
                          type="button"
                          className="withdraw_sec_item"
                          onClick={() => setSecUnavailable((p) => ({ ...p, authApp: !p.authApp }))}
                        >
                          <span className="withdraw_sec_item_left">
                            <span className="withdraw_sec_icon" aria-hidden="true">
                              <i className="ri-lock-2-line" />
                            </span>
                            <span className="withdraw_sec_item_txt">
                              <span className="withdraw_sec_item_title">Authenticator App</span>
                            </span>
                          </span>
                          <span className={`withdraw_sec_check${secUnavailable.authApp ? " is-checked" : ""}`} aria-hidden="true" />
                        </button>

                        <button
                          type="button"
                          className="withdraw_sec_item"
                          onClick={() => setSecUnavailable((p) => ({ ...p, passkeys: !p.passkeys }))}
                        >
                          <span className="withdraw_sec_item_left">
                            <span className="withdraw_sec_icon" aria-hidden="true">
                              <i className="ri-key-2-line" />
                            </span>
                            <span className="withdraw_sec_item_txt">
                              <span className="withdraw_sec_item_title">Passkeys</span>
                            </span>
                          </span>
                          <span className={`withdraw_sec_check${secUnavailable.passkeys ? " is-checked" : ""}`} aria-hidden="true" />
                        </button>
                      </div>

                      <button
                        type="button"
                        className="withdraw_sec_primary"
                        disabled={secUnavailableSelectedCount === 0}
                        onClick={() => {
                          setIsSecUnavailableOpen(false);
                          setIsSecResetConfirmOpen(true);
                        }}
                      >
                        Confirm Reset
                      </button>

                      <button type="button" className="withdraw_sec_help" onClick={() => navigate("/user_profile/support")}>
                        How does this work?
                      </button>
                    </div>
                  </div>
                ) : null}

                {false ? (
                  <div className="withdraw_confirm_overlay withdraw_sec_overlay" role="presentation">
                    <div className="withdraw_sec_confirm_modal" role="dialog" aria-modal="true" aria-label="Confirm reset">
                      <button
                        type="button"
                        className="withdraw_confirm_close"
                        aria-label="Close"
                        onClick={() => setIsSecResetConfirmOpen(false)}
                      >
                        ×
                      </button>

                      <div className="withdraw_sec_confirm_hero" aria-hidden="true">
                        <img src="/images/protected_icon.svg" alt="" />
                      </div>
                      <div className="withdraw_sec_confirm_title">Are You Sure You Want to Reset Your Security Methods?</div>

                      <label className="withdraw_sec_confirm_ack">
                        <input type="checkbox" checked={secResetAck} onChange={(e) => setSecResetAck(e.target.checked)} />
                        <span>
                          In order to protect your account, withdrawals, P2P selling, and payment services may be disabled for 48 to 72
                          hours after you make this change
                        </span>
                      </label>

                      <div className="withdraw_sec_confirm_actions">
                        <button type="button" className="withdraw_sec_btnGhost" onClick={() => setIsSecResetConfirmOpen(false)}>
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="withdraw_sec_btnPrimary"
                          disabled={!secResetAck}
                          onClick={() => {
                            setIsSecResetConfirmOpen(false);
                            setIsSecReqOpen(true);
                            setSecReqDone({ authApp: false, email: false, phone: false, passkeys: false });
                          }}
                        >
                          Confirm
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}

                {false ? (
                  <div className="withdraw_confirm_overlay withdraw_sec_overlay" role="presentation">
                    <div className="withdraw_sec_req_modal sec-req-invert-icons security-verification-requirements" role="dialog" aria-modal="true" aria-label="Security Verification Requirements">
                      <div className="withdraw_sec_req_topbar">
                        <button
                          type="button"
                          className="withdraw_choose_back"
                          aria-label="Back"
                          onClick={() => {
                            setIsSecReqOpen(false);
                            setIsSecUnavailableOpen(true);
                          }}
                        >
                          <i className="ri-arrow-left-long-line" aria-hidden="true" />
                        </button>
                        <button
                          type="button"
                          className="withdraw_confirm_close"
                          aria-label="Close"
                          onClick={() => setIsSecReqOpen(false)}
                        >
                          ×
                        </button>
                      </div>

                      <div className="withdraw_sec_req_title">Security Verification Requirements</div>
                      <div className="withdraw_sec_req_subtitle">You need to complete all of the following verifications to continue.</div>

                      <div className="withdraw_sec_req_progress">
                        <strong>{secReqCompleted}</strong> / {secReqTotal}
                      </div>

                      <div className="withdraw_sec_req_list">
                        {secRequirementsMode === "passkeys_only" ? (
                          <>
                            <button
                              type="button"
                              className="withdraw_sec_req_item"
                              onClick={() => {
                                setSecReqDone((p) => ({ ...p, passkeys: true }));
                                setIsSecReqOpen(false);
                                setIsPasskeyOpen(true);
                              }}
                            >
                              <span className="withdraw_sec_req_left">
                                <i className="ri-key-2-line" aria-hidden="true" />
                                <span>
                                  <span className="withdraw_sec_req_name">Passkeys</span>
                                  <span className="withdraw_sec_req_desc">Verify with biometrics or security keys</span>
                                </span>
                              </span>
                              <span className="withdraw_sec_req_right" aria-hidden="true">
                                {secReqDone.passkeys ? (
                                  <i className="ri-check-line withdraw_sec_req_check" />
                                ) : (
                                  <i className="ri-arrow-right-s-line withdraw_sec_req_arrow" />
                                )}
                              </span>
                            </button>
                          </>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="withdraw_sec_req_item"
                              onClick={() => {
                                setIsSecReqOpen(false);
                                setIsAuthAppOpen(true);
                              }}
                            >
                              <span className="withdraw_sec_req_left">
                                <i className="ri-lock-2-line" aria-hidden="true" />
                                <span>
                                  <span className="withdraw_sec_req_name">Authenticator App</span>
                                </span>
                              </span>
                              <span className="withdraw_sec_req_right" aria-hidden="true">
                                {secReqDone.authApp ? (
                                  <i className="ri-check-line withdraw_sec_req_check" />
                                ) : (
                                  <i className="ri-arrow-right-s-line withdraw_sec_req_arrow" />
                                )}
                              </span>
                            </button>

                            {secUnavailable.phone ? (
                              <button
                                type="button"
                                className="withdraw_sec_req_item"
                                onClick={() => {
                                  setIsSecReqOpen(false);
                                  setIsMobileVerifyOpen(true);
                                }}
                              >
                                <span className="withdraw_sec_req_left">
                                  <i className="ri-smartphone-line" aria-hidden="true" />
                                  <span>
                                    <span className="withdraw_sec_req_name">Phone Number</span>
                                  </span>
                                </span>
                                <span className="withdraw_sec_req_right" aria-hidden="true">
                                  {secReqDone.phone ? (
                                    <i className="ri-check-line withdraw_sec_req_check" />
                                  ) : (
                                    <i className="ri-arrow-right-s-line withdraw_sec_req_arrow" />
                                  )}
                                </span>
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="withdraw_sec_req_item"
                                onClick={() => {
                                  setIsSecReqOpen(false);
                                  setIsEmailVerifyOpen(true);
                                }}
                              >
                                <span className="withdraw_sec_req_left">
                                  <i className="ri-mail-line" aria-hidden="true" />
                                  <span>
                                    <span className="withdraw_sec_req_name">Email</span>
                                  </span>
                                </span>
                                <span className="withdraw_sec_req_right" aria-hidden="true">
                                  {secReqDone.email ? (
                                    <i className="ri-check-line withdraw_sec_req_check" />
                                  ) : (
                                    <i className="ri-arrow-right-s-line withdraw_sec_req_arrow" />
                                  )}
                                </span>
                              </button>
                            )}
                          </>
                        )}
                      </div>

                      {secRequirementsMode === "passkeys_only" ? (
                        <button type="button" className="withdraw_sec_req_link" onClick={openSecurityUnavailableFlow}>
                          My Passkeys Are Not Available
                        </button>
                      ) : (
                        <button
                          type="button"
                          className="withdraw_sec_req_link"
                          onClick={() => {
                            setIsSecReqOpen(false);
                            setIsPasskeyOpen(true);
                          }}
                        >
                          Use Passkeys to Complete Verification
                        </button>
                      )}
                    </div>
                  </div>
                ) : null}

                {isRequestSubmittedOpen ? (
                  <div className="withdraw_confirm_overlay withdraw_sec_overlay" role="presentation">
                    <div className="withdraw_facial_modal withdraw_facial_result" role="dialog" aria-modal="true" aria-label="Request Submitted">
                      <button type="button" className="withdraw_confirm_close" aria-label="Close" onClick={closeResetResultOverlays}>
                        ×
                      </button>
                      <div className="withdraw_facial_submitHero" aria-hidden="true" />
                      <div className="withdraw_facial_submitTitle">Request Submitted</div>
                      <div className="withdraw_facial_subtitle">
                        Your request has been successfully submitted. Please wait while we process it.
                      </div>
                      <button
                        type="button"
                        className="withdraw_sec_primary"
                        onClick={() => {
                          setIsRequestSubmittedOpen(false);
                          setIsSecurityResetSuccessOpen(true);
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ) : null}

                {isSecurityResetSuccessOpen ? (
                  <div className="withdraw_confirm_overlay withdraw_sec_overlay" role="presentation">
                    <div className="withdraw_facial_modal withdraw_facial_result" role="dialog" aria-modal="true" aria-label="Security reset success">
                      <button type="button" className="withdraw_confirm_close" aria-label="Close" onClick={closeResetResultOverlays}>
                        ×
                      </button>
                      <div className="withdraw_facial_successHero" aria-hidden="true" />
                      <div className="withdraw_facial_submitTitle">Security Methods Reset Successfully</div>
                      <div className="withdraw_facial_subtitle">
                        Your passkeys have been removed. You can login with your password. You need to wait for 24 hours before you can
                        submit another reset application.
                      </div>
                      <button
                        type="button"
                        className="withdraw_sec_primary"
                        onClick={() => {
                          setIsSecurityResetSuccessOpen(false);
                          setIsSecReqOpen(true);
                        }}
                      >
                        OK
                      </button>
                    </div>
                  </div>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      ) : null}
    </>
  );
}
